export default __webpack_public_path__ + "static/media/logo-lg-1920w.8085221b.avif";